module.exports = __webpack_public_path__ + "static/img/LL-1.b0d22790.png";